import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Box,
  Button,
  ButtonBase,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  styled,
} from "@mui/material";
import PopoverLayout from "components/Layouts/popovers/PopoverLayout";
import { Small } from "components/Typography";
import { Fragment, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

// styled components
const StyledSmall = styled(Small)(({ theme }) => ({
  display: "block",
  padding: "5px 1rem",
  cursor: "pointer",
  "&:hover": {
    color: theme.palette.primary.main,
    backgroundColor:
      theme.palette.mode === "light"
        ? theme.palette.secondary.light
        : theme.palette.divider,
  },
}));

const StyledBox = styled(Box)(({ theme }) => ({
  paddingBottom: "8px",
}));

const StyledDialogContentText = styled(DialogContentText)(({ theme }) => ({
  color: "black",
}));

interface ScheduleModalMenuProps {
  handleRemove: () => void;
}

const ScheduleModalMenu: React.FC<ScheduleModalMenuProps> = ({
  handleRemove,
}) => {
  const anchorRef = useRef(null);
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);

  const handleCloseMenu = () => {
    setOpen(false);
  };

  const handleCancelDelete = () => {
    setOpenDeleteConfirmation(false);
    handleCloseMenu();
  };

  const handleDeleteConfirmation = () => {
    handleCancelDelete();
    handleRemove();
  };

  return (
    <Fragment>
      <ButtonBase disableRipple ref={anchorRef} onClick={() => setOpen(true)}>
        <IconButton aria-label="Main">
          <MoreVertIcon sx={{ marginLeft: 0.5 }} />
        </IconButton>
      </ButtonBase>

      <PopoverLayout
        hiddenViewButton
        maxWidth={230}
        minWidth={200}
        popoverOpen={open}
        anchorRef={anchorRef}
        popoverClose={() => setOpen(false)}
      >
        <StyledBox pt={1}>
          <StyledSmall onClick={() => setOpenDeleteConfirmation(true)}>
            {t("Remover")}
          </StyledSmall>
        </StyledBox>
      </PopoverLayout>

      <Dialog
        open={openDeleteConfirmation}
        onClose={handleCancelDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmação"}</DialogTitle>

        <DialogContent>
          <StyledDialogContentText id="alert-dialog-description">
            Tem certeza que deseja remover o Agendamento?
          </StyledDialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            {t("Cancelar")}
          </Button>
          <Button
            onClick={handleDeleteConfirmation}
            sx={{ color: "error.main" }}
          >
            {t("Deletar")}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ScheduleModalMenu;
